export default __webpack_public_path__ + "static/media/prev_icon.64ddad94.svg";